import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isNumber from "lodash/isNumber";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Paper, IdNumberCheck, CreditApplyForm, SignDocument, BorrowerWorkPlaceTab, BorrowerIncomeTab, BorrowerExpenseTab, BorrowerExternalCreditTab, BorrowerFiles, PayOff, WizardLayout, useUser } from 'components';
import { showApiError } from 'utils';
import { addCreditGuarantor } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";
var BASE_STEPS = [{
  key: 'borrower',
  label: 'Клиент'
}, {
  key: 'details',
  label: 'Данни'
}, {
  key: 'credit',
  label: 'Кредит'
}];
var GUARANTOR_STEPS = [{
  key: 'guarantor',
  label: 'Поръчител'
}, {
  key: 'guarantor-details',
  label: 'Данни поръчител'
}];
var SIGN_STEP = {
  key: 'sign',
  label: 'Подписване'
};
var PAYOFF_STEP = {
  key: 'payoff',
  label: 'Изплащане'
};

var AddCredit = function AddCredit(_ref) {
  var _location$state, _steps;

  var history = _ref.history,
      location = _ref.location;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      borrowerIdNumber = _ref2.borrowerIdNumber,
      refinanceData = _ref2.refinanceData,
      creditFormData = _ref2.creditFormData;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      borrowerData = _useState4[0],
      setBorrowerData = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      guarantorData = _useState6[0],
      setGuarantorData = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      credit = _useState8[0],
      setCredit = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      hasGuarantor = _useState10[0],
      setHasGuarantor = _useState10[1];

  var topRef = useRef();
  var canApprove = userInfo === null || userInfo === void 0 ? void 0 : userInfo.can_approve;
  useEffect(function () {
    var _topRef$current;

    (_topRef$current = topRef.current) === null || _topRef$current === void 0 ? void 0 : _topRef$current.scrollIntoView({
      behavior: 'smooth'
    });
  }, [activeStep]); // Build dynamic steps based on whether guarantor is required

  var steps = useMemo(function () {
    var result = [].concat(BASE_STEPS);
    if (hasGuarantor) result.push.apply(result, GUARANTOR_STEPS);
    result.push(SIGN_STEP);
    if (canApprove) result.push(PAYOFF_STEP);
    return result;
  }, [hasGuarantor, canApprove]); // Map logical step keys to the old numeric system

  var stepKey = (_steps = steps[activeStep - 1]) === null || _steps === void 0 ? void 0 : _steps.key;

  var handleNext = function handleNext(jumpTo) {
    if (_isNumber(jumpTo)) setActiveStep(jumpTo);else setActiveStep(function (prev) {
      return prev + 1;
    });
  };

  var handleBack = function handleBack() {
    setActiveStep(function (prev) {
      return Math.max(1, prev - 1);
    });
  };

  var handleGoToCredits = function handleGoToCredits() {
    return history.push('/credits');
  };

  var handleStepClick = function handleStepClick(step) {
    if (step < activeStep) setActiveStep(step);
  };

  var handleCreditCreated = function handleCreditCreated(data) {
    setCredit(data); // Detect if guarantor was requested — step 3 sets this via onNext
  };

  var handleAddGuarantor = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$addCreditGuara, _yield$addCreditGuara2, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return addCreditGuarantor(credit === null || credit === void 0 ? void 0 : credit.id, {
                guarantor_id: guarantorData === null || guarantorData === void 0 ? void 0 : guarantorData.id
              });

            case 2:
              _yield$addCreditGuara = _context.sent;
              _yield$addCreditGuara2 = _slicedToArray(_yield$addCreditGuara, 2);
              err = _yield$addCreditGuara2[1];

              if (!err) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 7:
              handleNext();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddGuarantor() {
      return _ref3.apply(this, arguments);
    };
  }(); // Wrap onNext from CreditApplyForm to detect guarantor flow


  var handleCreditNext = function handleCreditNext(jumpTo) {
    // If jumpTo is 4 in old system, that means guarantor was requested
    // Old flow: step 3 → 4 (guarantor) or step 3 → 6 (sign)
    if (jumpTo === 4) {
      setHasGuarantor(true);
      var idx = [].concat(BASE_STEPS, GUARANTOR_STEPS).findIndex(function (s) {
        return s.key === 'guarantor';
      });
      setActiveStep(idx + 1);
    } else if (jumpTo === 6) {
      setHasGuarantor(false);

      var _idx = [].concat(BASE_STEPS, [SIGN_STEP]).findIndex(function (s) {
        return s.key === 'sign';
      });

      setActiveStep(_idx + 1);
    } else handleNext(jumpTo);
  };

  var renderStep = function renderStep() {
    switch (stepKey) {
      case 'borrower':
        return ___EmotionJSX(IdNumberCheck, {
          onNext: handleNext,
          onClose: handleGoToCredits,
          data: borrowerData,
          borrowerIdNumber: borrowerIdNumber,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrowerData(data);
          }
        });

      case 'details':
        return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(BorrowerWorkPlaceTab, {
          margin: "0 0 2em 0",
          idNumber: borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number,
          borrower: borrowerData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrowerData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                work_place: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerIncomeTab, {
          idNumber: borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number,
          borrower: borrowerData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrowerData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                incomes: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerExternalCreditTab, {
          idNumber: borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number,
          borrower: borrowerData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrowerData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                external_credits: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerExpenseTab, {
          margin: "0 0 2em 0",
          idNumber: borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number,
          borrower: borrowerData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrowerData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                expenses: data
              });
            });
          }
        }), ___EmotionJSX(Paper, {
          header: "\u0424\u0430\u0439\u043B\u043E\u0432\u0435",
          margin: "0 0 2em 0"
        }, ___EmotionJSX(BorrowerFiles, {
          borrowerIdNumber: borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.id_number,
          documents: borrowerData === null || borrowerData === void 0 ? void 0 : borrowerData.documents,
          onNext: handleNext
        })));

      case 'credit':
        return ___EmotionJSX(CreditApplyForm, {
          borrower: borrowerData,
          credit: credit,
          refinanceData: refinanceData,
          initialCreditData: creditFormData,
          onNext: handleCreditNext,
          onBack: handleBack,
          onCreditChange: handleCreditCreated
        });

      case 'guarantor':
        return ___EmotionJSX(IdNumberCheck, {
          onNext: handleNext,
          onClose: handleGoToCredits,
          data: guarantorData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setGuarantorData(data);
          },
          isGuarantor: true
        });

      case 'guarantor-details':
        return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(BorrowerWorkPlaceTab, {
          margin: "0 0 2em 0",
          idNumber: guarantorData === null || guarantorData === void 0 ? void 0 : guarantorData.id_number,
          borrower: guarantorData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setGuarantorData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                work_place: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerIncomeTab, {
          idNumber: guarantorData === null || guarantorData === void 0 ? void 0 : guarantorData.id_number,
          borrower: guarantorData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setGuarantorData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                incomes: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerExternalCreditTab, {
          idNumber: guarantorData === null || guarantorData === void 0 ? void 0 : guarantorData.id_number,
          borrower: guarantorData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setGuarantorData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                external_credits: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerExpenseTab, {
          margin: "0 0 2em 0",
          idNumber: guarantorData === null || guarantorData === void 0 ? void 0 : guarantorData.id_number,
          borrower: guarantorData,
          onBorrowerChange: function onBorrowerChange(data) {
            return setGuarantorData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                expenses: data
              });
            });
          }
        }), ___EmotionJSX(Paper, {
          header: "\u0424\u0430\u0439\u043B\u043E\u0432\u0435",
          margin: "0 0 2em 0"
        }, ___EmotionJSX(BorrowerFiles, {
          borrowerIdNumber: guarantorData === null || guarantorData === void 0 ? void 0 : guarantorData.id_number,
          documents: guarantorData === null || guarantorData === void 0 ? void 0 : guarantorData.documents,
          onNext: handleAddGuarantor
        })));

      case 'sign':
        return ___EmotionJSX(SignDocument, {
          creditId: credit === null || credit === void 0 ? void 0 : credit.id,
          creditStatus: credit === null || credit === void 0 ? void 0 : credit.status,
          credit: credit,
          onNext: function onNext() {
            return canApprove ? handleNext() : handleGoToCredits();
          }
        });

      case 'payoff':
        return ___EmotionJSX(PayOff, {
          credit: credit
        });

      default:
        return null;
    }
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    ref: topRef
  }), ___EmotionJSX(WizardLayout, {
    title: "\u0421\u044A\u0437\u0434\u0430\u0439 \u043A\u0440\u0435\u0434\u0438\u0442",
    steps: steps,
    activeStep: activeStep,
    onStepClick: handleStepClick,
    onBack: handleGoToCredits,
    borrower: borrowerData,
    guarantor: hasGuarantor ? guarantorData : null,
    credit: credit
  }, renderStep()));
};

AddCredit.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
};
export default AddCredit;